import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  constructor(
    private http: MiraieService,
    public authService: AuthService,
  ) { }


  // 個人　予実一覧
  //   user_code:ユーザコード
  //   year:年度
  getPersonalStatusList(user_code, year: number) {
    var url = "status/list";

    let param = { user_code, year, };

    return this.http.post(url, param);
  }

  //事業別　予実一覧
  //   division_code:事業部コード（0=全部）
  //   year:年度
  getDivisionStatusList(division_code, year: number) {
    var url = "status/all-list";

    let param = { division_code, year, };

    return this.http.post(url, param);
  }

  //個人予実
  //   user_code:ユーザコード
  //   year:年
  //   month:月
  //   week:週
  getPersonalStatus(user_code, year: number, month: number, week: number) {
    var url = "status";

    //ログインユーザーのコードをもらってくる
    //let user_code = this.authService.getUserCode();
    let param = { user_code, year, month, week };

    return this.http.post(url, param);
  }

  //全体、事業所別の予実
  //   division_code:事業部コード（0=全部）
  //   year:年
  //   month:月
  //   week:週
  getDivisionStatus(division_code: number, year: number, month: number, week: number) {
    var url = "status/all";

    let param = { division_code, year, month, week };

    return this.http.post(url, param);
  }

  //目標保存
  updatePersonalStatus(Report) {
    var url = "status/update";

    return this.http.post(url, Report);
  }

  //目標保存
  updateDivisionStatus(Report) {
    var url = "status/all-update";

    return this.http.post(url, Report);
  }
}
